document.querySelectorAll(".fg-epopup").forEach(function (root) {
  var enabled = root.getAttribute("data-enabled");
  if (enabled === "false") return;

  var SESSION_KEY = "fg_epopup_dismissed";

  if (sessionStorage.getItem(SESSION_KEY)) return;

  var delay = Number(root.getAttribute("data-delay")) || 3;
  var savedScrollY = 0;
  var klaviyoKey = root.getAttribute("data-klaviyo-key") || "";
  var klaviyoList = root.getAttribute("data-klaviyo-list") || "";
  var successMsg =
    root.getAttribute("data-success-msg") || "You're in! Check your inbox.";

  var closeBtn = root.querySelector(".fg-epopup__close");
  var backdrop = root.querySelector(".fg-epopup__backdrop");
  var form = root.querySelector(".fg-epopup__form");
  var input = root.querySelector(".fg-epopup__input");
  var btn = root.querySelector(".fg-epopup__btn");
  var successEl = root.querySelector(".fg-epopup__success");
  var errorEl = root.querySelector(".fg-epopup__error");

  function lockScroll() {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + savedScrollY + "px";
    document.body.style.width = "100%";
  }

  function unlockScroll() {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, savedScrollY);
  }

  function showPopup() {
    savedScrollY = window.scrollY;
    lockScroll();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add("is-visible");
        if (input) input.focus();
      });
    });
    document.addEventListener("keydown", onKeyDown);
  }

  function closePopup() {
    root.classList.remove("is-visible");
    unlockScroll();
    sessionStorage.setItem(SESSION_KEY, "1");
    document.removeEventListener("keydown", onKeyDown);

    root.addEventListener(
      "transitionend",
      function hide() {
        root.setAttribute("hidden", "");
        root.removeEventListener("transitionend", hide);
      },
      { once: true },
    );
  }

  function onKeyDown(e) {
    if (e.key === "Escape") {
      closePopup();
      return;
    }

    if (e.key === "Tab") {
      var focusable = root.querySelectorAll(
        'button, input, [tabindex]:not([tabindex="-1"])',
      );
      var focusArr = [];
      for (var i = 0; i < focusable.length; i++) {
        focusArr.push(focusable[i]);
      }
      if (focusArr.length === 0) return;
      var first = focusArr[0];
      var last = focusArr[focusArr.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showMessage(el, msg) {
    el.textContent = msg;
    el.removeAttribute("hidden");
  }

  function hideMessages() {
    if (successEl) successEl.setAttribute("hidden", "");
    if (errorEl) errorEl.setAttribute("hidden", "");
  }

  function submitToKlaviyo(email, callback) {
    if (!klaviyoKey || !klaviyoList) {
      callback(true);
      return;
    }

    var payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: email },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: klaviyoList,
            },
          },
        },
      },
    };

    fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" + klaviyoKey,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-10-15",
        },
        body: JSON.stringify(payload),
      },
    )
      .then(function (res) {
        callback(res.status === 202 || res.ok);
      })
      .catch(function () {
        callback(false);
      });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  if (backdrop) {
    backdrop.addEventListener("click", closePopup);
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      hideMessages();

      var email = input ? input.value.trim() : "";

      if (!validateEmail(email)) {
        showMessage(errorEl, "Please enter a valid email address.");
        if (input) {
          input.setAttribute("aria-invalid", "true");
          input.focus();
        }
        return;
      }

      if (input) input.removeAttribute("aria-invalid");

      if (btn) {
        btn.disabled = true;
        btn.textContent = "Subscribing\u2026";
      }

      submitToKlaviyo(email, function (ok) {
        if (ok) {
          showMessage(successEl, successMsg);
          if (form) form.setAttribute("hidden", "");
          setTimeout(function () {
            closePopup();
          }, 2200);
        } else {
          showMessage(errorEl, "Something went wrong. Please try again.");
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.getAttribute("data-label") || "Join Now";
          }
        }
      });
    });
  }

  if (btn) {
    btn.setAttribute("data-label", btn.textContent.trim());
  }

  function schedulePopup() {
    setTimeout(showPopup, delay * 1000);
  }

  var _triggered = false;
  var _interactionEvents = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];

  function onFirstInteraction() {
    if (_triggered) return;
    _triggered = true;
    _interactionEvents.forEach(function(ev) {
      document.removeEventListener(ev, onFirstInteraction);
    });
    root.removeAttribute("hidden");
    schedulePopup();
  }

  _interactionEvents.forEach(function(ev) {
    document.addEventListener(ev, onFirstInteraction, { passive: true });
  });
});
